import { useEffect, useRef, useState } from 'react';
import SidePanel from '../../side-panel/side-panel';
import { SidePanelType } from '../../side-panel/types';
import ButtonPseudo from '../../button/button-pseudo';
import ButtonSecondary from '../../button/button-secondary';
import { EnumNostroTabs } from '../types';
import ButtonPrimary from '../../button/button-primary';
import SidePanelLoader from '../../side-panel/loader';
import NostroTransactionSidepanelRead from './nostro-transaction-sidepanel-read';
import NostroTransactionContentForm from './nostro-transaction-content-form';
import Popup from '../../popup/popup';
import SignaturePopup from '../signature-popup';
import PermissionDenied from '../../permission-denied/permission-denied';
import GeneralLedgerSidepanel from '../general-ledger/general-ledger-sidepanel';
import { NostroTransactionSidePanelTypes } from './types';
import usePrevious from '../../../hooks/use-previous';

import styles from '../transaction.module.css';

export default function NostroTransactionSidepanel({
  tabs,
  panelIsOpen,
  handleClose,
  transactionInfo,
  isLoading,
  title,
  statusesInfo,
  onRollbackStatus,
  onNextStatus,
  handleSubmit,
  control,
  isDisabledSaveButton,
  currencies,
  toAccounts,
  fromAccounts,
  toPartnerPSPs,
  fromPartnerPSPs,
  paymentsTypes,
  okButtonText,
  errors,
  isEditable,
  children,
  onSearchAutocomplete,
  toAccountsIsLoading,
  fromAccountsIsLoading,
  toPartnerPSPsIsLoading,
  fromPartnerPSPsIsLoading,
  paymentTypeIsFilled = false,
  toPartnerPspIsFilled = false,
  fromPartnerPspIsFilled = false,
  baseellaStatus,
  logs,
  enableEdit = false,
  isCreateForm = false,
  checkError,
  changeLogs,
  currencyId,
  updateFromAccountBalance,
  fromAccountBalance,
  balanceFromAccountIsLoading,
  toAccountBalance,
  updateToAccountBalance,
  balanceToAccountIsLoading,
  isDirty,
  checkInProgress,
  onChangeStatusPopup,
  statusPopupVisible,
  setStatusPopupVisible,
  validateCode,
  signaturePopupVisible,
  sendCode,
  validateCodeInProgress,
  transactionId,
  signatures,
  errorSidepanel,
  setRejectPopupVisible,
  onReject,
  rejectInProgress,
  rejectPopupVisible,
  errorMessageSignature,
  createAllowed,
  updateStatusIsLoading,
  isLoadingStatuses,
  transactionCheckError,
  onSignatureCancelClick,
  activePermission,
  amount,
  setAmount,
  latestQueuedStatus,
  statusChangeError,
  createdByOrganizationId,
  onChangeStatusPopupLoading,
  glTransactionsIsLoading,
  glTransactions,
  onGlTransactionClick,
  glTransactionIsLoading,
  glTransaction,
  clearGlTransactionState,
  expandedGLTransactionCreditBalance,
  expandedGLTransactionDebitBalance,
  expendedDebitBalanceIsLoading,
  expendedCreditBalanceIsLoading,
  deleteTransactionError,
  onDeleteTransactions,
  deleteTransactionInProgress,
  deleteTransactionDisabled,
  createIsLoading,
  updateIsLoading,
  internalError,
  canSignTransaction,
  sendCodeInProgress,
  currenciesList,
  onDuplicate,
  duplicate,
  fields,
  getGeneralLedgerTransactionValues,
  isLoadingLogs,
  getLogsTransactionByIdAction,
  getSignaturesTransactionById,
  isLoadingSignatures,
  overdraftEnabled,
  fromPspAccountsList,
  toPspAccountsList,
  fromAccountBalanceInfo,
  toAccountBalanceInfo,
  getTransactionChangeLogs,
  changeLogsIsLoading,
  users,
  transactionChangeLogsPagination,
  changeLogsIsFetching,
  sidepanelExpandedKey,
  transactionComments,
  transactionCommentsPagination,
  getTransactionCommentsAction,
  commentsIsLoading,
  commentsIsFetching,
  onAddCommentToTransaction,
  addCommentInProgress,
  addCommentIsSuccess,
  onEditCommentInTransaction,
  editTransactionCommentInProgress,
  editTrancastionCommentIsSuccess,
  onDeleteCommentInTransaction,
  deleteCommentInTransactionInProgress,
  deleteCommentInTranscationIsSuccess,
  caspList,
  paymentType,
  getIntegrationLogs,
  integrationLogsIsLoading,
  integrationLogsIsFetching,
  integrationLogs,
  integrationLogsPagination,
  fromPspAccountsPagination,
  fromPspAccountsNextPageIsLoading,
  fromPspAccountsOnScroll,
  toPspAccountsPagination,
  toPspAccountsNextPageIsLoading,
  toPspAccountsOnScroll,
  setValue,
  purposeCodeVisible,
  purposeCodes,
  purposeCodesIsLoading,
  purposeCodesNextPageIsLoading,
  onScrollPurposeCodes,
  purposeCodesPagination,
  clearErrors,
  deleteDisabled,
}: NostroTransactionSidePanelTypes): React.JSX.Element {
  const [dirtyPopupVisible, setDirtyPopupVisible] = useState(false);
  const [scroll, setScroll] = useState(0);
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const [transactionSidePanelVisible, setTransactionSidepanelVisible] =
    useState(panelIsOpen);
  const [activeTab, setActiveTab] = useState(EnumNostroTabs.GENERAL);
  const [glTransactionSidepanelVisible, setGlTransactionSidePanelVisible] =
    useState(false);
  const [deleteTransactionPopupVisible, setDeleteTransactionPopupVisible] =
    useState(false);
  const [confirmationPopupVisible, setConfirmationPopupVisible] =
    useState(false);

  const prevEditInProgress = usePrevious(updateIsLoading);

  const tabsItems = [
    { name: 'General Info', value: EnumNostroTabs.GENERAL },
    { name: 'Status log', value: EnumNostroTabs.LOG },
    { name: 'Change Log', value: EnumNostroTabs.CHANGE_LOG },
    { name: 'Signatures', value: EnumNostroTabs.SIGNATURES },
    { name: 'Accounting entries', value: EnumNostroTabs.GL_TRANSACTIONS },
    { name: 'Comments', value: EnumNostroTabs.COMMENTS },
    { name: 'Integration Logs', value: EnumNostroTabs.INTEGRATION_LOGS },
  ];

  const handleScroll = () => {
    setScroll((prev) => {
      if (prev !== Number(scrollRef.current?.scrollTop)) {
        return Number(scrollRef.current?.scrollTop);
      }
      return prev;
    });
  };

  useEffect(() => {
    if (duplicate) {
      setActiveTab(EnumNostroTabs.GENERAL);
    }
  }, [duplicate]);

  useEffect(() => {
    const element = scrollRef.current;

    element?.addEventListener('scroll', handleScroll);

    return () => {
      element?.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    setTransactionSidepanelVisible(panelIsOpen);
  }, [panelIsOpen]);

  useEffect(() => {
    if (!updateIsLoading && prevEditInProgress) {
      setConfirmationPopupVisible(false);
    }
  }, [updateIsLoading, prevEditInProgress]);

  let content;
  let contentError;

  if (checkError) {
    contentError = checkError;
  } else if (errors) {
    contentError = 'There are errors in some fields';
  } else if (errorSidepanel) {
    contentError = errorSidepanel;
  } else if (deleteTransactionError) {
    contentError = deleteTransactionError;
  }

  if (isLoading && !internalError) {
    content = <SidePanelLoader />;
  } else if (enableEdit && !internalError) {
    if ((isCreateForm && createAllowed) || transactionId) {
      content = (
        <NostroTransactionContentForm
          transactionInfo={transactionInfo}
          isLoading={isLoading}
          statusesInfo={statusesInfo}
          onRollbackStatus={onRollbackStatus}
          onNextStatus={onNextStatus}
          control={control}
          errors={errors}
          isEditable={isEditable}
          currencies={currencies}
          paymentsTypes={paymentsTypes}
          toAccounts={toAccounts}
          fromAccounts={fromAccounts}
          toPartnerPSPs={toPartnerPSPs}
          fromPartnerPSPs={fromPartnerPSPs}
          toAccountsIsLoading={toAccountsIsLoading}
          fromAccountsIsLoading={fromAccountsIsLoading}
          toPartnerPSPsIsLoading={toPartnerPSPsIsLoading}
          fromPartnerPSPsIsLoading={fromPartnerPSPsIsLoading}
          onSearchAutocomplete={onSearchAutocomplete}
          paymentTypeIsFilled={paymentTypeIsFilled}
          toPartnerPspIsFilled={toPartnerPspIsFilled}
          fromPartnerPspIsFilled={fromPartnerPspIsFilled}
          baseellaStatus={baseellaStatus}
          logs={logs}
          isCreateForm={isCreateForm}
          changeLogs={changeLogs}
          currencyId={currencyId}
          updateFromAccountBalance={updateFromAccountBalance}
          fromAccountBalance={fromAccountBalance}
          balanceFromAccountIsLoading={balanceFromAccountIsLoading}
          toAccountBalance={toAccountBalance}
          updateToAccountBalance={updateToAccountBalance}
          balanceToAccountIsLoading={balanceToAccountIsLoading}
          signatures={signatures}
          setRejectPopupVisible={setRejectPopupVisible}
          sendCodeInProgress={sendCodeInProgress}
          sendCode={sendCode}
          parentRef={scrollRef}
          parentScroll={scroll}
          updateStatusIsLoading={updateStatusIsLoading}
          isLoadingStatuses={isLoadingStatuses}
          activePermission={activePermission}
          amount={amount}
          setAmount={setAmount}
          latestQueuedStatus={latestQueuedStatus}
          createdByOrganizationId={createdByOrganizationId}
          tabs={tabsItems}
          setActiveTab={setActiveTab}
          activeTab={activeTab}
          glTransactionsIsLoading={glTransactionsIsLoading}
          glTransactions={glTransactions}
          setGlTransactionSidePanelVisible={setGlTransactionSidePanelVisible}
          onGlTransactionClick={onGlTransactionClick}
          setTransactionSidepanelVisible={setTransactionSidepanelVisible}
          canSignTransaction={canSignTransaction}
          currenciesList={currenciesList}
          fields={fields}
          getGeneralLedgerTransactionValues={getGeneralLedgerTransactionValues}
          isLoadingLogs={isLoadingLogs}
          getLogsTransactionByIdAction={getLogsTransactionByIdAction}
          getSignaturesTransactionById={getSignaturesTransactionById}
          isLoadingSignatures={isLoadingSignatures}
          overdraftEnabled={overdraftEnabled}
          fromPspAccountsList={fromPspAccountsList}
          toPspAccountsList={toPspAccountsList}
          fromAccountBalanceInfo={fromAccountBalanceInfo}
          toAccountBalanceInfo={toAccountBalanceInfo}
          getTransactionChangeLogs={getTransactionChangeLogs}
          changeLogsIsLoading={changeLogsIsLoading}
          users={users}
          transactionChangeLogsPagination={transactionChangeLogsPagination}
          changeLogsIsFetching={changeLogsIsFetching}
          transactionId={transactionId}
          transactionComments={transactionComments}
          transactionCommentsPagination={transactionCommentsPagination}
          getTransactionCommentsAction={getTransactionCommentsAction}
          commentsIsLoading={commentsIsLoading}
          commentsIsFetching={commentsIsFetching}
          onAddCommentToTransaction={onAddCommentToTransaction}
          addCommentInProgress={addCommentInProgress}
          addCommentIsSuccess={addCommentIsSuccess}
          onEditCommentInTransaction={onEditCommentInTransaction}
          editTransactionCommentInProgress={editTransactionCommentInProgress}
          editTrancastionCommentIsSuccess={editTrancastionCommentIsSuccess}
          onDeleteCommentInTransaction={onDeleteCommentInTransaction}
          deleteCommentInTransactionInProgress={
            deleteCommentInTransactionInProgress
          }
          deleteCommentInTranscationIsSuccess={
            deleteCommentInTranscationIsSuccess
          }
          caspList={caspList}
          paymentType={paymentType}
          getIntegrationLogs={getIntegrationLogs}
          integrationLogsIsLoading={integrationLogsIsLoading}
          integrationLogsIsFetching={integrationLogsIsFetching}
          integrationLogs={integrationLogs}
          integrationLogsPagination={integrationLogsPagination}
          fromPspAccountsPagination={fromPspAccountsPagination}
          fromPspAccountsNextPageIsLoading={fromPspAccountsNextPageIsLoading}
          fromPspAccountsOnScroll={fromPspAccountsOnScroll}
          toPspAccountsPagination={toPspAccountsPagination}
          toPspAccountsNextPageIsLoading={toPspAccountsNextPageIsLoading}
          toPspAccountsOnScroll={toPspAccountsOnScroll}
          setValue={setValue}
          purposeCodeVisible={purposeCodeVisible}
          purposeCodes={purposeCodes}
          purposeCodesIsLoading={purposeCodesIsLoading}
          purposeCodesNextPageIsLoading={purposeCodesNextPageIsLoading}
          onScrollPurposeCodes={onScrollPurposeCodes}
          purposeCodesPagination={purposeCodesPagination}
          clearErrors={clearErrors}
        />
      );
    } else if (!createAllowed && isCreateForm) {
      content = <PermissionDenied />;
    }
  } else if (internalError) {
    content = <div className={styles.internalError}>{internalError}</div>;
  } else {
    content = (
      <NostroTransactionSidepanelRead
        tabs={tabs}
        parentRef={scrollRef}
        parentScroll={scroll}
        deletedAt={transactionInfo?.deletedAt}
      />
    );
  }

  let footerButton;

  if (enableEdit) {
    if (transactionId && isEditable) {
      footerButton = (
        <ButtonPrimary
          text={okButtonText}
          disabled={isDisabledSaveButton}
          onClick={() => setConfirmationPopupVisible(true)}
          bold
        />
      );
    } else if (isCreateForm && createAllowed) {
      footerButton = (
        <ButtonPrimary
          text={createIsLoading ? 'Loading...' : okButtonText}
          disabled={isDisabledSaveButton}
          onClick={sendCode}
          bold
        />
      );
    }
  }

  return (
    <>
      <SidePanel
        type={SidePanelType.Transactions}
        closeOnClickOutside
        isOpen={transactionSidePanelVisible}
        onClose={isDirty ? () => setDirtyPopupVisible(true) : handleClose}
        title={title}
        footerVisible={Boolean(control)}
        className={styles.transactionSidepanel}
        errorSidepanel={contentError || statusChangeError}
        childrenRef={scrollRef}
        checkInProgress={checkInProgress}
        transactionCheckError={transactionCheckError}
        checkText="Checking transaction..."
        sidepanelExpandedKey={sidepanelExpandedKey}
        footer={
          <>
            {!internalError && footerButton}
            {!isLoading && (
              <>
                {transactionId && onDuplicate && (
                  <ButtonSecondary
                    text="Duplicate"
                    onClick={onDuplicate}
                    className={styles.duplicateButton}
                    disabled={Boolean(
                      updateStatusIsLoading ||
                      deleteTransactionInProgress ||
                      updateIsLoading,
                    )}
                    bold
                  />
                )}
                {!internalError && transactionId && !deleteDisabled && (
                  <ButtonSecondary
                    text={
                      deleteTransactionInProgress
                        ? 'Loading...'
                        : 'Delete transaction'
                    }
                    className={`button-white button-warning ${styles.deleteTransactionButton}`}
                    disabled={
                      deleteTransactionInProgress ||
                      deleteTransactionDisabled ||
                      updateStatusIsLoading ||
                      deleteTransactionInProgress ||
                      updateIsLoading
                    }
                    onClick={() => setDeleteTransactionPopupVisible(true)}
                    bold
                  />
                )}
              </>
            )}

            <ButtonPseudo text="Cancel" onClick={handleClose} bold />
          </>
        }
      >
        <>
          {children}
          {content}
        </>
      </SidePanel>
      <GeneralLedgerSidepanel
        panelIsOpen={glTransactionSidepanelVisible}
        handleClose={() => {
          if (clearGlTransactionState) {
            clearGlTransactionState();
          }
          setTransactionSidepanelVisible(true);

          setGlTransactionSidePanelVisible(false);
          setActiveTab(EnumNostroTabs.GL_TRANSACTIONS);
        }}
        transaction={glTransaction}
        isLoading={glTransactionIsLoading as boolean}
        title="GL Transaction"
        debitAccountBalance={expandedGLTransactionDebitBalance}
        creditAccountBalance={expandedGLTransactionCreditBalance}
        debitBalanceIsLoading={expendedDebitBalanceIsLoading}
        creditBalanceIsLoading={expendedCreditBalanceIsLoading}
        sidepanelExpandedKey="nostro-gl-transaction"
      />
      <Popup
        title="Delete transaction?"
        onCancelClick={() => setDeleteTransactionPopupVisible(false)}
        onOkClick={() =>
          onDeleteTransactions && onDeleteTransactions(transactionId as string)
        }
        cancelButtonText="Cancel"
        okButtonText={deleteTransactionInProgress ? 'Loading...' : 'Delete'}
        isVisible={deleteTransactionPopupVisible}
        isLoading={deleteTransactionInProgress}
        parent={document.getElementById('delete-popup-wrapper') as HTMLElement}
      >
        <div>
          {deleteTransactionError && (
            <div className={styles.transactionDeleteError}>
              {deleteTransactionError}
            </div>
          )}
        </div>
      </Popup>
      <Popup
        title="You have unsaved changes that will be lost"
        description="Are you sure you want to close this form?"
        onCancelClick={() => setDirtyPopupVisible(false)}
        onOkClick={handleClose}
        cancelButtonText="Cancel"
        okButtonText="Close"
        isVisible={dirtyPopupVisible}
        parent={document.getElementById('dirty-popup') as HTMLElement}
      />
      <Popup
        title="You have unsaved changed"
        description="You want to change the status of a transaction, but you have unsaved changes on the transaction. Please select one of the following options:"
        onCancelClick={() =>
          setStatusPopupVisible && setStatusPopupVisible(false)
        }
        onOkClick={onChangeStatusPopup}
        cancelButtonText="Cancel"
        okButtonText="Save changes and change status"
        isVisible={Boolean(statusPopupVisible)}
        parent={document.getElementById('status-popup') as HTMLElement}
        isLoading={onChangeStatusPopupLoading}
      />
      <SignaturePopup
        signaturePopupVisible={signaturePopupVisible}
        validateCode={validateCode}
        validateCodeInProgress={validateCodeInProgress}
        errorMessageSignature={errorMessageSignature}
        onSignatureCancelClick={onSignatureCancelClick}
      />
      <Popup
        title="The transaction will be rejected"
        onCancelClick={() =>
          setRejectPopupVisible && setRejectPopupVisible(false)
        }
        onOkClick={onReject}
        cancelButtonText="Cancel"
        okButtonText="Yes, Reject"
        isVisible={rejectPopupVisible as boolean}
        parent={document.getElementById('signature-popup') as HTMLElement}
        isLoading={rejectInProgress}
      />
      <Popup
        title="Are you sure to save all changes?"
        onCancelClick={() => setConfirmationPopupVisible(false)}
        onOkClick={handleSubmit}
        isLoading={updateIsLoading}
        cancelButtonText="Cancel"
        okButtonText={updateIsLoading ? 'Loading...' : 'Save changes'}
        isVisible={confirmationPopupVisible}
        parent={document.getElementById('status-popup') as HTMLElement}
        okButtonDisabled={updateIsLoading}
      />
      <div id="status-popup" />
      <div id="dirty-popup" />
      <div id="signature-popup" />
      <div id="delete-popup-wrapper" />
    </>
  );
}
